import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const getSingleProperty = async (propertyId) => {
  try {
    const propertyDocument = doc(db, "properties", propertyId);
    const propertySnapshot = await getDoc(propertyDocument);
    let propertyData = {
      ...propertySnapshot.data(),
    };
    return propertyData;
  } catch (error) {
    console.log(error);
  }
};

export default getSingleProperty;
